import { v4 as generateUuidV4 } from "uuid";

const generateUuid = generateUuidV4;

export default generateUuid;
